import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { LoadingBar, TableForm, Pagination } from 'components/Commons';

import cm from 'helpers/commons';

class PushMessageList extends Component {
  render() {
    const { page, pagerow, open, pageClick } = this.props.listFn,
      { list } = this.props;

    let pushList = '',
      loading = '',
      p_page = page,
      p_pagerow = pagerow,
      p_totalcount = 0,
      tabledata = {
        header: {
          main: [
            { data: '#', textAlign: 'left' },
            { data: '내용', textAlign: 'left' },
            { data: '작성자', textAlign: 'left' },
            { data: '전송시각', textAlign: 'left' },
            { data: '전송', textAlign: 'left' },
            { data: '상태', textAlign: 'left' }
          ]
        },
        body: {
          message: '사용자 PUSH 메세지 전송 내역이 존재하지 않습니다.',
          main: null
        }
      };

    if (list) {
      if (list.data) {
        const { paging, push } = list.data;

        if (paging) {
          p_page = paging.page;
          p_pagerow = paging.pagerow;
          p_totalcount = paging.totalcount;
        }

        if (push && push.length > 0) {
          tabledata.body.main = push.map((item) => {
            let status = '-'; //,
            // btnTxt = item.status.text,
            // btnFunc = null;

            if (item.status.value === 'COMPLETE') {
              status = 'O';
            } else {
              status = 'X';

              // if(item.status.value === "ERROR") {
              //   btnTxt = item.status.text;
              //   btnFunc = this.sendRepush;
              // }
            }

            let obj = {
              row: [
                {
                  data: item.idx,
                  textAlign: 'left',
                  fontWeight: 'bold'
                },
                {
                  data: item.content,
                  textAlign: 'left',
                  whiteSpace: 'pre-wrap'
                },
                {
                  data: item.writer,
                  textAlign: 'left'
                },
                {
                  data: item.senddate
                    ? cm.yyyyMMdd(new Date(item.senddate)) + ' ' + cm.hhmmss(new Date(item.senddate))
                    : 'UNKWON',
                  textAlign: 'left'
                },
                {
                  data: status,
                  textAlign: 'left'
                },
                {
                  data: item.status.text,
                  textAlign: 'left'
                }
              ]
            };

            return obj;
          });
        }
      } else {
        if (list.response) {
          pushList = list.response.data.message;
        }
      }
    }
    const columnWidth = [40, 1200, 90, 152, 48, 77];

    return (
      <div>
        <div className="table-box">
          <TableForm tabledata={tabledata} columnWidth={columnWidth} />
        </div>

        <div className="table-paging">
          <Pagination
            page={p_page}
            pageRow={p_pagerow}
            pageBlock={10}
            totalCount={p_totalcount}
            pageClick={pageClick}
          />
        </div>
      </div>
    );
  }
}

PushMessageList = connect((state) => ({
  list: state.company.list //,
  //add : state.company.add
}))(PushMessageList);

export default PushMessageList;
